import React from "react";

const TopHeader = () => {
    return (
        <div className="bg-dark top-header">
            <img class="site-logo__img" src="images/logo.png" alt="logo" />{" "}
        </div>
    );
};

export default TopHeader;
